import { makeStyles } from '@mui/styles';
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  appointmentListContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    flex: 2,
  },
  visitFrequencyContainer: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    padding: '20px 24px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    backgroundColor: 'white',
  },
  appointmentCardContainer: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
    minWidth: 680,
    width: '100%',
    backgroundColor: 'white',
  },
  appointmentHeader: {
    padding: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  appointmentBody: {
    borderTop: `1px solid ${colors.neutral100}`,
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  appointmentDetailsBody: {
    display: 'flex',
    gap: 12,
  },
  appointmentCard: {
    background: colors.white,
    display: 'flex',
    width: '100%',
    padding: '24px',
    justifyContent: 'space-between',
  },
  appointmentCardFooter: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    gap: 32,
    alignItems: 'center',
  },
  appointmentCardFooterBlock: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    color: colors.neutral600,
  },
  appointmentCardTitle: {
    fontWeight: 700,
    fontSize: 22,
    lineHeight: '28px',
    letterSpacing: '-0.22px',
    color: colors.neutral900,
  },
  appointmentCardSubTitle: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral700,
  },
  appointmentFooter: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  appointmentFooterText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  appointmentFooterBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary500,
    maxHeight: '20px',
  },
  addAppointmentBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    width: '100%',
    color: colors.primary500,
    display: 'flex',
    gap: 8,
    '& svg': {
      width: 18,
      height: 18,
    },
  },
  appointmentIcon: {
    width: 13.33,
    height: 13.33,
  },
  visitFrequency: {
    width: 22,
    height: 22,
  },
  // badge: {
  //   borderRadius: 100,
  //   height: 18,
  //   fontSize: 12,
  //   lineHeight: '16px',
  //   fontWeight: 600,
  //   color: colors.primary600,
  //   borderColor: colors.primary200,
  // },
  emptyTitle: {
    fontWeight: 400,
    fontSize: 36,
    lineHeight: '44px',
    color: colors.neutral900,
  },
  emptySubTitle: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
  },
});
